import { DOCUMENT, Location } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { PublicDataService, SeoService } from '../core/services';
import { UsersService } from '../core/services/users/users.service';
import { Response2 } from '../utils/interfaces/reponse';
import { PublicCardData, SeoData, Usuario } from '../utils/models';

@Injectable({
  providedIn: 'root',
})
export class SeoGuard implements CanActivate {
  publicCardData: PublicCardData;
  seoImage: string;

  constructor(
    private location: Location,
    private publicData: PublicDataService,
    private router: Router,
    //private readonly seo: SeoService,
    private seo: SeoService,
    private usersService: UsersService,
    @Inject(DOCUMENT) private doc: any
  ) {
    this.publicCardData = new PublicCardData();
    this.seoImage = '';
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    await this.getSeo(state);
    return true;
  }

  private getSeo(state: RouterStateSnapshot): Promise<void> {
    return new Promise((resolve) => {
      const alias = state.url.replace('/', '').split('?')[0];
      
      //
      console.log("Vicman::getSeo ", alias )

      this.usersService.getUserByAliasV2(alias).subscribe(
        (response: Response2<Usuario>) => {
          const usuario = response.data;

          if (!usuario.habilitado) {
            this.router.navigate(['/not-available']);
            return;
          }

          if (usuario.tarjetaPortada === null) {
            this.router.navigate(['/not-found']);
            return;
          }

          this.usersService.usuario = usuario;

          const idTarjeta = usuario.tarjetaPortada.idTarjeta;
          const urlFotoPerfil = usuario.tarjetaPortada.urlFotoPerfil;

          this.seoImage = this.seo.buildImageSeo(idTarjeta, urlFotoPerfil);

          const temp: SeoData = new SeoData().deserialize(usuario);
          temp.urlFotoPerfil = this.seoImage;
          temp.nombre = usuario.tarjetaPortada.nombre;

          temp.url = this.doc.location.href;
          
          console.log("Vicman:: temp.url", temp.url);

          temp.descripcion = this.assignDescription(usuario);

          const favIcon: any = this.doc.querySelector('#icono');
          favIcon.href = this.seoImage;
          const imageSafari: any = this.doc.querySelector('#iconoSafariPerfil');
          imageSafari.href = this.seoImage;
          const imageSafari2: any = this.doc.querySelector('#iconoSafari');
          imageSafari2.href = this.seoImage;

          // const metaIcon = this.doc.querySelector('#meta-icon');
          // metaIcon.content = this.seoImage;

          // const metaTitle = this.doc.querySelector('#meta-title')
          // metaTitle.content = usuario.tarjetaPortada.nombre;
            

          

          // //>>Vicman revisar 
          //  console.log("VicMan::#meta-icon ", metaIcon);
          //  console.log("VicMan::#meta-title ", metaTitle);

          //  console.log("VicMan:: paso 1", temp);

          this.seo.updateSeo(temp); // Vicman: Parece que aqui actualiza la tarjeta
          resolve();
        },
        (error) => {
          const status = error.status;
          switch (status) {
            case 404:
              console.log("VicMan:: paso al error 404 url::" , alias);
              this.router.navigate(['/not-found']);
              break;
            case 500:
              console.log("VicMan:: paso al error 500 url::",  alias);
              this.router.navigate(['/internal-error']);
              break;
            default:
              break;
          }
        }
      );
    });
  }

  private assignDescription(usuario: Usuario): string {
    if (
      usuario.tarjetaPortada?.Empresa !== '' &&
      usuario.tarjetaPortada?.Empresa !== null &&
      usuario.empresa === null
    ) {
      return usuario.tarjetaPortada?.Empresa;
    }
    if (usuario.empresa !== null) {
      return usuario.empresa?.descripcion;
    }
    if (usuario.tarjetaPortada?.tarjetaPortadaDetalle === null) {
      return '';
    }

    return usuario.tarjetaPortada?.tarjetaPortadaDetalle.descripcion;
  }
}
